import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FaseEstado } from '../_models/fase-estado';

@Injectable({
  providedIn: 'root'
})
export class FaseEstadoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/fasesEstados';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FaseEstado[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FaseEstado[] ) );
  }

  listadoPorFase( idFase: string ) {
    return this.httClient.get( this.rutServicio + '/fase/' + idFase ).pipe( map( res => res as FaseEstado[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FaseEstado ) );
  }

  crear( regCrear: FaseEstado ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FaseEstado ) );
  }

  actualizar( regActualizar: FaseEstado ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FaseEstado ) );
  }
}
